import { render, staticRenderFns } from "./CompareConfigs2.vue?vue&type=template&id=212bd558"
import script from "./CompareConfigs2.vue?vue&type=script&lang=js"
export * from "./CompareConfigs2.vue?vue&type=script&lang=js"
import style0 from "./CompareConfigs2.vue?vue&type=style&index=0&id=212bd558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports